import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  values: PropTypes.shape({
    email_address: PropTypes.string,
  }),
};

const EmailVerificationSentStep = ({ values }) => {
  return (
    <Fragment>
      <h4 className="px-2">
        Success! <br /> A verification email has been sent to{' '}
        {values.email_address}.
      </h4>
      <p className="px-2">Please verify your email to continue.</p>
    </Fragment>
  );
};

EmailVerificationSentStep.propTypes = propTypes;

export default EmailVerificationSentStep;
